module.exports = __webpack_public_path__ + "static/media/growth.fc6bf5ef.svg";